import gql from 'graphql-tag'

export const PRODUCT_BY_VARIANT_IDS = gql`
  fragment ProductVariantsIdsFragment on Product {
    id
    title
    division
    productTypeId
    rank {
      count
      rank
    }
    mainCategoryUrlKey
    mainMenuUrlKey
    mainVariant {
      brief
      id
      title
      labels
      price
      vatRate
      discountPrice
      priceRrp
      priceType
      rrpSavePercent
      defaultActualPrice
      discountPromotionPrice
      mainMenuPath
      availableOutlets
      availability {
        ...productAvailabilityFragment
      }
      estimatedDeliveries {
        ...productEstimatedDeliveryFragment
      }
      brand {
        title
      }
      mediaIds
      variantUrl
      isAvailable
    }
    marketplace {
      marketplacePartnerTitle
    }
  }
`
